import React from "react";
import FullLogo from "../resources/artiqlogo-seethrough-blue.png";
import { notify } from "./Toast/Toast";

export function NavMenu(props) {
  function exitMenu() {
    props.setShowMenu(false);
  }

  function handleClick(page) {
    props.setActivePage(page);
    exitMenu();
  }

  function logOut() {
    props.setShowMenu(false);
    props.setActivePage("Dashboard");
    props.setUser(null);
    localStorage.clear();
  }

  return (
    <div className="NavMenuContainer">
      <div className="NavMenu">
        <div>
          <img src={FullLogo} alt="ARTIQ" style={{ width: "90%" }} />
          <div>
            <h2
              className="nav hoverButton"
              onClick={() => handleClick("Dashboard")}
            >
              Dashboard
            </h2>
            <h2
              className="nav hoverButton"
              onClick={() => handleClick("Inventeringar")}
            >
              Inventeringar
            </h2>
            <h2
              className="nav hoverButton"
              onClick={() => handleClick("Produkter")}
            >
              Produkter
            </h2>
            <h2
              className="nav hoverButton"
              onClick={() => handleClick("Barer")}
            >
              Barer
            </h2>
            <h2
              className="nav hoverButton"
              onClick={() => handleClick("Användare")}
            >
              Användare
            </h2>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "4vh",
              width: "100%",
              padding: "1vh",
            }}
            className="hoverButton"
            onClick={logOut}
          >
            <h3>Logga ut</h3>
          </div>
        </div>
      </div>
      <div onClick={exitMenu} style={{ width: "100%" }}></div>
    </div>
  );
}
